<template>
  <v-container fluid class="fill-height background-wave">
    <morph-wave-background />
    <v-row class="header-banner" align="center" justify="center">
      <div>
        <div class="header-text">
          Hello! I'm <b>{{ firstName }}</b> &#9787;
        </div>
        <div class="text-h6">
          <contact-bar />
          <br />
          <br />
          <chevron-down link_to="about-me" />
          <br />
          <br />
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import baseData from 'data/base.json';
import ChevronDown from '@/components/utilities/ChevronDown';
import ContactBar from '@/components/utilities/ContactBar';
import MorphWaveBackground from './MorphWaveBackground.vue';

export default {
  name: 'HelloBanner',

  components: {
    ChevronDown,
    ContactBar,
    MorphWaveBackground,
  },

  data: () => ({
    firstName: baseData.firstName,
  }),
};
</script>

<style lang="scss">
.header-text {
  font-family: 'Avenir', 'Roboto', Helvetica, Arial, sans-serif !important;
  /* letter-spacing: -0.02em; */
  line-height: 6rem; 
  font-size: 5rem;
}

.background-wave {
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.header-banner {
  text-align: center;
  height: 100vh;
  background-color: #011525;
  color: white;
  text-shadow: 4px 4px 9px black;
}

.contact-icon {
  text-decoration: none;
  color: white;
  padding: 0 10px;
  font-size: 1.1em;
}
</style>
